import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import config from '../../../utils/EnvironmentSwitcher'; // Import config utility

const SerialMonitor = () => {
      const [port, setPort] = useState(null);
      const [output, setOutput] = useState('');
      const [configInfo, setConfigInfo] = useState('');

      useEffect(() => {
            // Set config info for display
            setConfigInfo(`Environment: ${config.environment}, FHIR URL: ${config.fhirUrl}`);
            
            // Check if the port is already open when the component mounts
            const checkPortStatus = async () => {
                  try {
                        const ports = await navigator.serial.getPorts();
                        if (ports.length > 0) {
                              const openPort = ports.find(p => p.readable || p.writable);
                              if (openPort) {
                                    setPort(openPort);
                                    console.log('Serial port is already open.');
                                    toast.success('Serial port is already open.');
                              }
                        }
                  } catch (error) {
                        console.error('Error checking port status:', error);
                  }
            };

            checkPortStatus();
      }, []);

      const connectSerial = async () => {
            try {
                  const selectedPort = await navigator.serial.requestPort();
                  await selectedPort.open({ baudRate: 115200 });
                  setPort(selectedPort);

                  const textDecoder = new TextDecoderStream();
                  const readableStreamClosed = selectedPort.readable.pipeTo(textDecoder.writable);
                  const reader = textDecoder.readable.getReader();

                  // Add environment info to output
                  setOutput(`Connected to serial port. Using ${config.environment} environment.\n`);

                  while (true) {
                        const { value, done } = await reader.read();
                        if (done) {
                              reader.releaseLock();
                              break;
                        }
                        setOutput((prevOutput) => prevOutput + value);
                  }
            } catch (error) {
                  console.error('Error:', error);
                  toast.error(`Serial connection error: ${error.message}`);
            }
      };

      const disconnectSerial = async () => {
            try {
                  if (port) {
                        await port.close();
                        setPort(null);
                        toast.info('Serial port disconnected');
                  }
            } catch (error) {
                  console.error('Error closing the port:', error);
                  toast.error(`Error closing port: ${error.message}`);
            }
      };

      return (
            <div>
                  <div className="mb-2">
                        <small className="mb-2">{configInfo}</small>
                  </div>
                  <button onClick={connectSerial} disabled={!!port}>Connect</button>
                  <button onClick={disconnectSerial} disabled={!port}>Disconnect</button>
                  <div id="output" style={{ whiteSpace: 'pre-wrap', border: '1px solid #ccc', padding: '10px', marginTop: '10px' }}>
                        {output}
                  </div>
            </div>
      );
};

export default SerialMonitor; 

